module.exports = __webpack_public_path__ + "static/media/CAPEMISA---Logotipo-negativo.0327dd97.png";